module.exports = __webpack_public_path__ + "static/media/Product or Brand Logo.d884d5d8.jpg";